import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import './i18n'; // инициализация i18next
import { consumeSessionHandoff } from './utils/sessionHandoff';
import { initAnalytics } from './analytics/core';
import { initOverflowTitle } from './utils/overflowTitle';

// Аналитика и запись сессий. Какой провайдер поднимется — PostHog, Яндекс.
// Метрика или оба сразу — решает REACT_APP_ANALYTICS внутри ядра. Конфиг
// каждого провайдера лежит в analytics/providers/, здесь его быть не должно:
// иначе точка входа станет местом, где расходятся два инстанса.
initAnalytics();

// Полный текст в подсказке, когда он не влез в поле ввода — для ВСЕХ полей сразу.
initOverflowTitle();

// Sentry — отслеживание ошибок фронтенда
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 0,
    replaysOnErrorSampleRate: process.env.NODE_ENV === 'production' ? 1.0 : 0,
  });
}

// Service Worker в деве не регистрируем никогда — наоборот, снимаем ранее
// зарегистрированный и чистим его кэши. SW кэширует оболочку
// (stale-while-revalidate), а бандлы webpack-dev-server меняют хэши — старый
// index.html из кэша ссылается на отсутствующие чанки → ошибка → перезагрузка
// → цикл (особенно на мобиле).
//
// В проде регистрация НЕ отсюда — она вызывается из registerServiceWorker()
// (см. utils/serviceWorker.js) один раз, когда человек авторизован. Раньше
// она стояла прямо здесь, безусловно на любой странице — из-за этого браузер
// уже на экране регистрации/логина считал сайт «готовым к установке» и мог
// предложить добавить его на экран раньше, чем у тенанта появилось лого,
// которое можно было бы поставить на эту иконку.
if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'production') {
  navigator.serviceWorker.getRegistrations()
    .then(regs => regs.forEach(r => r.unregister()))
    .catch(() => {});
  if (window.caches) {
    caches.keys().then(keys => keys.forEach(k => caches.delete(k))).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Сессия, приехавшая с другого origin (конец онбординга: app.fixty.io →
// <тенант>.fixty.io), забирается ДО рендера: AuthProvider читает localStorage
// один раз на маунте, и токен, положенный позже, он уже не увидит — человек
// моргнёт экраном логина. Промис не реджектится: нет кода в адресе или обмен
// не удался — рендерим как обычно.
consumeSessionHandoff().finally(() => {
  root.render(<React.StrictMode><App /></React.StrictMode>);
});
